// app/javascript/controllers/party_settings_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    submit() {
        this.element.requestSubmit()
    }
}